import React from "react";
import { graphql } from "gatsby";
import { Link } from "gatsby";
import Layout from "../components/layout";
import { TagCloud } from 'react-tagcloud';
import {
	Jumbotron,
	Container,
	Row,
	Col,
	Card,
} from 'reactstrap';

export const query = graphql`
query HomePageQuery {
  allSitePage(filter: {context: {linkBackward: {eq: "/"}}}) {
    edges {
      node {
        path
        context {
          pageContent {
            value
            count
          }
        }
      }
    }
  }
}
`

const homePage = ({data}) => {
	return (
		<Layout>
			<Jumbotron>
				<Container>
					<h1 className="display-4">COVID-19 Literature Clustering Project</h1>
					<p className="lead">Hierarchical NMF is used to discover latent topics that depend on each other, allowing for organization of data into a tree structure.</p>
					<hr className="my-2" />
					<p>This website is a result of the paper that describes an attempt to organize existing literature on coronaviruses, other pandemics, and the current COVID-19 outbreak in response to the call to action issued by the White House Office of Science and Technology policy and posted on the Semantic Scholar and Kaggle websites.</p>
				</Container>
			</Jumbotron>
			<Container>
				<h1>Please select categories below:</h1>
				<Row>
					{data.allSitePage.edges.map((item, index) => {
						return <Col sm="4" key={`page_data_${index}`}>
							<Card body>
								<TagCloud
									minSize={12}
									maxSize={35}
									disableRandomColor={true}
									tags={item.node.context.pageContent}
								/>
								<Link to={item.node.path} style={{ marginTop: "15px" }} className="btn btn-primary">See More</Link>
							</Card>
						</Col>
					})}
				</Row>
			</Container>
		</Layout>
	)
}
export default homePage